export const FETCH_COMMENTS_REQUEST = 'FETCH_COMMENTS_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_FAILURE = 'FETCH_COMMENTS_FAILURE';

export const FETCH_COMMENT_REQUEST = 'FETCH_COMMENT_REQUEST';
export const FETCH_COMMENT_SUCCESS = 'FETCH_COMMENT_SUCCESS';
export const FETCH_COMMENT_FAILURE = 'FETCH_COMMENT_FAILURE';

export const UPDATE_COMMENTS_REQUEST = 'UPDATE_COMMENTS_REQUEST';
export const UPDATE_COMMENTS_SUCCESS = 'UPDATE_COMMENTS_SUCCESS';
export const UPDATE_COMMENTS_FAILURE = 'UPDATE_COMMENTS_FAILURE';

export const DELETE_COMMENTS_REQUEST = 'DELETE_COMMENTS_REQUEST';
export const DELETE_COMMENTS_SUCCESS = 'DELETE_COMMENTS_SUCCESS';
export const DELETE_COMMENTS_FAILURE = 'DELETE_COMMENTS_FAILURE';

export const CLEAR_COMMENT_ERRORS = 'CLEAR_COMMENT_ERRORS';
export const CLEAR_COMMENT_SUCCESS = 'CLEAR_COMMENT_SUCCESS';